import { createContext, type PropsWithChildren, useCallback, useEffect, useMemo } from 'react'

interface MessagingBusPayload {
	type: string
	value: any
}

interface MessagingBusContextData {
	broadcast: (type: string, value: any) => void
}

export const MessagingBusContext = createContext<MessagingBusContextData>({
	broadcast: () => {},
})

export default function MessagingBusProvider({ children }: PropsWithChildren) {
	const busInstance = useMemo(() => new BroadcastChannel('_wll_tabs'), [])

	useEffect(() => {
		busInstance.onmessage = (e: MessageEvent<MessagingBusPayload>) => {
			const { type } = e.data

			switch (type) {
				case 'SWITCH_TENANT':
				case 'UPDATE_TENANT':
				case 'LOGOUT':
					window.location.reload()
					break
			}
		}
	}, [busInstance])

	const broadcast: MessagingBusContextData['broadcast'] = useCallback(
		(type, value) => busInstance.postMessage({ type, value }),
		[busInstance]
	)

	const contextValue = useMemo(() => ({ broadcast }), [broadcast])

	return <MessagingBusContext.Provider value={contextValue}>{children}</MessagingBusContext.Provider>
}
